// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aadaafb5","284":"7ea1341e","626":"6481de5c","651":"235e8576"}[chunkId] + ".chunk.js";
};